import type FolderViewStateStore from 'mini-mail-folder-store/lib/store/schema/FolderViewStateStore';
import mailStore from 'owa-mail-store/lib/store/Store';
import { action } from 'satcheljs/lib/legacy';

function shouldAddFavoriteFolder(folderId: string, folderStore: FolderViewStateStore): boolean {
    // Add the folders if
    // - the folder is not in favorites yet. This could happen during firstRun, if user already has the default favorite folder.
    // - the folder is in the folder store. Skip unsupported favorites type or stale folders which could be deleted in other clients.
    const folderTable = mailStore.folders.folderTable;
    return folderTable.size > 0
        ? folderId &&
              folderStore.orderedFavoritesFolderIds.indexOf(folderId) === -1 &&
              folderTable.has(folderId)
        : false;
}

export default action('tryAddSingleFavoriteFolderToStore')(
    function tryAddSingleFavoriteFolderToStore(
        folderId: string,
        folderStore: FolderViewStateStore
    ) {
        if (shouldAddFavoriteFolder(folderId, folderStore)) {
            folderStore.orderedFavoritesFolderIds.push(folderId);
        }
    }
);
